import React, { useState } from 'react';
import { Button, Card, CardBody, CustomInput } from 'reactstrap';
import { CustomCardHeader } from '../../../components/common/custom-card-header/CustomCardHeader';
import * as Yup from 'yup';
import './transfer.scss';
import { Formik, Form } from 'formik';
import { FormGroup } from 'reactstrap';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import { Colxx } from '../../../components/common/CustomBootstrap';
import {
  CommonFormInput,
  CommonFormInputGroup,
  CommonFormRadioGroup,
  CustomCheckBox,
} from '../../../components/common/CustomFormComponents';
import { useUserContext } from '../../../context/UserContext';
import userAPI from '../../../services/API/user';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
  getFormattedMoneyString,
  getFormattedMoneyStringFromString,
  getNumberFromMoneyString,
} from '../../../helpers/utils';
import { LinkButton } from '../../../components/common/LinkButton';

export const Transfer = (props) => {
  const paymentModeOption = [
    { value: 'Paypal', label: 'Paypal', isChecked: true },
    { value: 'Venmo', label: 'Venmo', isChecked: false },
  ];
  const { loadTransactionList, onShowTransactionHistory, isSM } = props;
  const { user, setUser } = useUserContext();
  const [transfering, setTransfering] = useState(false);
  const [paymentModes, setPaymentModes] = useState(paymentModeOption);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [amountErrorMessage, setAmountErrorMessage] = useState(null);

  const currentBalance = user?.invoiced_due
    ? getFormattedMoneyString(
        user.earnings - getFormattedMoneyStringFromString(user.invoiced_due)
      )
    : getFormattedMoneyString(user.earnings);
  const initialValues = {
    mode: 'PayPal',
    receipientID: '',
    amount: '',
  };

  const transferValidationSchema = Yup.object().shape({
    receipientID: Yup.string()
      .required('Please enter the email')
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i, 'Invalid email'),
    amount: Yup.number()
      .positive("Amount can't be 0 or less")
      .max(
        getFormattedMoneyStringFromString(currentBalance),
        `You have only ${
          currentBalance ? getFormattedMoneyString(currentBalance) : ''
        }`
      )
      .required('Please enter the amount'),
  });

  const handleSubmit = async (values, { resetForm }) => {
    // dummy alert
    if (user.id && user.earnings && user.earningString) {
      const receipientID =
        values.mode === 'PayPal'
          ? user?.email_paypal ?? null
          : user?.email_venmo ?? null;
      if (receipientID) {
        const dataToSend = {
          user_id: user.id,
          amount: values.amount,
          recipient: {
            recipient_type: values.mode,
            recipient_id: receipientID,
          },
          recipient_email: values.receipientID,
        };
        setTransfering(true);
        try {
          const res = await userAPI.transferFund(dataToSend);

          if (res?.transfer && res?.transfer === 'success') {
            let newBalance =
              getNumberFromMoneyString(user.earnings) - values.amount;
            setUser({
              ...user,
              earnings: getNumberFromMoneyString(newBalance),
            });

            NotificationManager.success({
              message: 'Transferred Successfully',
            });
            setSuccessMessage('Transfer completed');
            setTimeout(() => {
              setSuccessMessage(null);
            }, 2500);
            resetForm({});
            // if (loadTransactionList) {
            //   loadTransactionList();
            // }
          } else {
            NotificationManager.success({
              message: 'Transferred Failed',
            });
            setSuccessMessage(
              'Oh no! There was an issue with your request. Please contact us for support.'
            );
            setTimeout(() => {
              setSuccessMessage(null);
            }, 2500);
          }
        } catch (error) {
          setErrorMessage(
            'Oh no! There was an issue with your request. Please contact us for support.'
          );
          setTimeout(() => {
            setErrorMessage(null);
          }, 2500);
          NotificationManager.error({
            message:
              'Oh no! There was an issue with your request. Please contact us for support.',
          });
        }

        setTransfering(false);
      }
    }
  };

  return (
    <Card
      // border='light'
      className='no-shadow wallet-cash-wrapper'
      style={{ border: `1px solid #2E2B2B`, backgroundColor: 'transparent' }}
    >
      <CustomCardHeader
        title='TRANSFER EARNINGS'
        handleActionBtnClick={() => {
          if (onShowTransactionHistory) {
            onShowTransactionHistory();
          }
        }}
      />
      <CardBody style={{ fontFamily: 'Brown' }}>
        <div className=' mb-5'>
          <span style={{ fontSize: 14 }}>
            Safely and securely transfer your earnings to your PayPal or Venmo
            account at anytime.
          </span>
        </div>
        <div className=' mb-5'>
          <span style={{ fontSize: 14 }}>
            <b>Current balance: </b>
            {currentBalance}
          </span>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={transferValidationSchema}
        >
          {({ values, setFieldValue, setFieldTouched, errors, touched }) => {
            return (
              <Form className='mb-4'>
                <FormGroup row>
                  <Colxx sm={12} className='transfer-options mb-4'>
                    <span style={{ fontSize: 14 }}>
                      Please choose a recipient account:
                    </span>
                    <CommonFormRadioGroup
                      name='mode'
                      value={values.mode}
                      // label='Please choose a recipient account:'
                      id='transfer-paypal'
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      showError={errors.mode && touched.mode}
                      error={errors.mode}
                      notInline={true}
                      options={[
                        { value: 'PayPal', label: 'Paypal' },
                        { value: 'Venmo', label: 'Venmo' },
                      ]}
                    />
                  </Colxx>
                  <Colxx sm={12} className={'mb-2'}>
                    <CommonFormInputGroup
                      label='Amount:'
                      type='number'
                      name='amount'
                      id='transfer-amount'
                      prepend='$'
                      onChange={(e) => {
                        setFieldValue('amount', e.target.value);
                        if (e.target.value <= 0) {
                          setAmountErrorMessage(`Amount can't be 0 or less`);
                        } else {
                          setAmountErrorMessage(null);
                        }
                      }}
                      showError={
                        (errors.amount && touched.amount) || amountErrorMessage
                      }
                      error={errors.amount || amountErrorMessage}
                    />
                  </Colxx>
                  <Colxx sm={12}>
                    <CommonFormInput
                      label='A receipt for this transaction will be sent to the following email address:'
                      type='email'
                      name='receipientID'
                      // placeholder={user?.email || 'example@duke.edu'}
                      id='transfer-receipientID'
                      showError={errors.receipientID && touched.receipientID}
                      error={errors.receipientID}
                    />
                  </Colxx>
                </FormGroup>

                <FormGroup row>
                  <Colxx
                    sm={12}
                    style={{ flexDirection: 'column' }}
                    className='d-flex flex-direction-column align-items-center justify-content-center'
                  >
                    {successMessage ? (
                      <span style={{ color: '#ACBAE1' }}>{successMessage}</span>
                    ) : errorMessage ? (
                      <span style={{ color: '#F96E4E' }}>{errorMessage}</span>
                    ) : null}
                    {user?.member && user?.invoiced_due > 0 ? (
                      <span style={{ color: '#F96E4E' }}>
                        You have unpaid invoices. Transfers blocked.
                      </span>
                    ) : (
                      <ButtonWithLoadingIcon
                        disabled={transfering}
                        type='submit'
                        loading={transfering}
                        color='primary'
                        size='lg'
                      >
                        TRANSFER
                      </ButtonWithLoadingIcon>
                    )}
                    {/* <LinkButton className={'mt-3'}>Cancel</LinkButton> */}
                  </Colxx>
                </FormGroup>
              </Form>
            );
          }}
        </Formik>
      </CardBody>
    </Card>
  );
};
